import React from 'react';
import campaignMock from '../img/png/campaign_mockup.png';
import { AiOutlineCheckCircle } from 'react-icons/ai';

function FrictionlessSolution() {
  return (
    <>
      <section className='frictionless d-flex justify-content-center align-items-center'>
        <div className='frictionless_container d-flex-row gap-3 align-items-center justify-content-between'>
          <div className='frictionless_container_left d-flex-col gap-1'>
            <div className='line'></div>
            <h2 className='text-title'>A Frictionless Solution</h2>
            <div className='text d-flex-col'>
              <div className='d-flex-row align-items-center gap-1'>
                <AiOutlineCheckCircle />
                <p className='text-gray'>Reach your ideal audience</p>
              </div>
              <div className='d-flex-row align-items-center gap-1'>
                <AiOutlineCheckCircle />
                <p className='text-gray'>
                  Save time with workflow efficiencies
                </p>
              </div>
              <div className='d-flex-row align-items-center gap-1'>
                <AiOutlineCheckCircle />
                <p className='text-gray'>
                  Control over the entire media-buying process
                </p>
              </div>
              <div className='d-flex-row align-items-center gap-1'>
                <AiOutlineCheckCircle />
                <p className='text-gray'>
                  Integrated across the digital advertising chain
                </p>
              </div>
            </div>
          </div>
          <div className='frictionless_container_right'>
            <img src={campaignMock} alt='background' />
          </div>
        </div>
      </section>
    </>
  );
}

export default FrictionlessSolution;
